import { Download } from 'lucide-react'
import { MriButton } from '@mriqbox/ui-kit'
import { useInstallPrompt } from '@/hooks/useInstallPrompt'

/**
 * Convite pra instalar o app, direto da pagina.
 *
 * Nao aparece sempre — e nem deveria: so o Chrome/Edge deixam uma pagina
 * disparar a instalacao, e mesmo neles o convite nao existe se a pessoa ja
 * instalou. Quando nao ha o que oferecer, o bloco inteiro sai do caminho em vez
 * de virar um botao que nao faz nada.
 */
export function InstallApp() {
    const { podeInstalar, abrindo, instalar } = useInstallPrompt()
    if (!podeInstalar) return null

    return (
        <div className="mt-8 flex flex-wrap items-center gap-3 rounded-xl border border-border/70 bg-card/50 p-3">
            <MriButton
                type="button"
                variant="outline"
                className="font-semibold"
                disabled={abrindo}
                onClick={() => void instalar()}
            >
                <Download className="mr-2 h-4 w-4" />
                Instalar o app
            </MriButton>
            <p className="text-[11px] leading-relaxed text-muted-foreground">
                Abre em janela própria, com ícone no computador.
                <br />
                É o mesmo site — atualiza sozinho, sem instalador.
            </p>
        </div>
    )
}
